var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_15128)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.0586,
    cy: 67,
    r: 33.5,
    fill: "#EAECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0371 3.5C65.0371 3.5 35.1919 3.51555 35.1452 3.51555C24.4154 3.58164 17.7715 10.6416 17.7715 21.4103V57.1608C17.7715 67.9839 24.466 75.0711 35.2891 75.0711C35.2891 75.0711 65.1304 75.0594 65.181 75.0594C75.9108 74.9933 82.5586 67.9295 82.5586 57.1608V21.4103C82.5586 10.5871 75.8603 3.5 65.0371 3.5Z",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 59H49.5",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 49H30.5",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75977 76.5693L2.56488 83.7455",
    stroke: "#513DD3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3516,
    cy: 18.3516,
    rx: 18.3516,
    ry: 18.3516,
    transform: "matrix(-1 0 0 1 40.875 44.5)",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "matrix(-1 0 0 1 37 48.5)",
    fill: "#EAECFF",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4506 29.5945H67.2215C65.3016 29.5934 63.7453 28.0383 63.7441 26.1183C63.7441 24.1983 65.3016 22.6433 67.2215 22.6421H72.4506",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8133 26.0387H67.4107",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5077 14.875H65.6722C69.4156 14.875 72.4504 17.9098 72.4504 21.6532V30.9236C72.4504 34.667 69.4156 37.7018 65.6722 37.7018H54.5077C50.7643 37.7018 47.7295 34.667 47.7295 30.9236V21.6532C47.7295 17.9098 50.7643 14.875 54.5077 14.875Z",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5879 20.7368H60.5615",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_15128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.68a89cc0fd12a2e3f86660db583467e1.svg";
export { ForwardRef as ReactComponent };